import React, { useEffect } from "react";
import styled from "styled-components";
import MojitoImg from "../Img/mojito.png";
import { v4 as uuidv4 } from "uuid";
import EmojiList from "../Asset/EmojiList";

const Box = styled.div`
  width: 100%;
  height: calc(100% - 45%);
  position: relative;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const Mojito = styled.img`
  height: 120px;
  position: absolute;
  bottom: -15px;
  z-index: 1000;
`;

const DropZone = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  width: 50px;
  height: 40px;
`;

const Top = () => {
  useEffect(() => {
    setInterval(emojiFalling, 800);
  }, []);
  const emojiFalling = () => {
    const emojiLength = EmojiList.length;
    const emojiNumber = () => {
      const RandVal = Math.floor(Math.random() * (emojiLength - 1 - 0 + 1));
      return RandVal;
    };
    const rightValue = () => {
      const RandVal = Math.floor(Math.random() * (30 - 1 + 1)) + 1;
      return RandVal;
    };
    const emjSrc = EmojiList[emojiNumber()][0];
    const unique = uuidv4();
    const falling = document.createElement("img");
    falling.classList.add("dD");
    falling.style.width = "24px";
    falling.style.height = "24px";
    falling.style.animation = "falling 1s";
    falling.style.position = "absolute";
    falling.style.right = rightValue() + "px";
    falling.className = unique;
    falling.src = emjSrc;
    document.getElementById("DZ").appendChild(falling);
    setTimeout(() => {
      const element = document.getElementsByClassName(unique);
      element[0].parentNode.removeChild(element[0]);
    }, 1000);
  };

  return (
    <Box>
      <Mojito src={MojitoImg}></Mojito>
      <DropZone id="DZ" className="dD"></DropZone>
    </Box>
  );
};

export default Top;
